export enum SPACING {
  SHORT = 1,
  COMMON = 3,
}
